import Vue from 'vue';
import Vuex from 'vuex';
import brand from '@/components/brand/storage';
import goods from '@/components/goods/storage';
import login from '@/components/login/storage';
import users from "@/components/users/storage";
import translations from "@/components/translations/storage";
import sites from "@/components/sites/storage";
import alert from "@/components/alert/storage";
import analytics from "@/components/analytics/storage";
import httpclient from "@/httpclient";
import order from "@/components/order/storage";
import settings from "@/components/settings/storage";
import suppliers from "@/components/suppliers/storage";
import competitors from "@/components/competitors/storage";
import countrySelectComponents from '@/components/components/countrySelect/storage';
import ai from "@/components/ai/storage";
import bulkDelete from "@/components/bulkDelete/storage"

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        brand,
        goods,
        login,
        users,
        translations,
        sites,
        alert,
        analytics,
        order,
        settings,
        suppliers,
        competitors,
        countrySelectComponents,
        ai,
        bulkDelete
    },
    state: {
        isLogin: false,
        name: '',
        secondName: '',
        userData: {},
        httpClient: httpclient,
        errorText: '',
        errorTime: '',
        infoText: '',
        bvModal: {},
        allowSection: [],
        sections: [],
    },
    getters: {
        getErrorTime: state => {
            return state.errorTime;
        },
        getAllowSection: state => {
            return state.allowSection;
        },
        getBvModal: state => {
            return state.bvModal;
        },
        getInfoText: state => {
            return state.infoText;
        },
        getErrorText: state => {
            return state.errorText;
        },
        getIsLogin: state => {
            return state.isLogin;
        },
        getName: state => {
            return state.name;
        },
        getSecondName: state => {
            return state.secondName;
        },
        getUserData: state => {
            return state.userData;
        },
        getHttpClient: state => {
            return state.httpClient;
        },
        SECTIONS: state => {
            return state.sections;
        },
    },
    mutations: {
        setErrorTime: (state, payload) => {
            return state.errorTime = payload;
        },
        setAllowSection: (state, payload) => {
            return state.allowSection = payload;
        },
        setBvModal: (state, payload) => {
            return state.bvModal = payload;
        },
        setInfoText: (state, payload) => {
            return state.infoText = payload;
        },
        setErrorText: (state, payload) => {
            let currentdate = new Date();
            state.errorTime =  currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/"
                + currentdate.getFullYear() + " @ "
                + currentdate.getHours() + ":"
                + currentdate.getMinutes() + ":"
                + currentdate.getSeconds();
            return state.errorText = payload;
        },
        setIsLogin: (state, payload) => {
            return state.isLogin = payload;
        },
        setName: (state, payload) => {
            return state.name = payload;
        },
        setSecondName: (state, payload) => {
            return state.secondName = payload;
        },
        setUserData: (state, payload) => {
            return state.userData = payload;
        },
        setAuthToken: (state, payload) => {
            return state.httpClient.defaults.headers.common['Auth-Token'] = payload;
        },
        SECTIONS: (state, payload) => {
            return state.sections = payload;
        },
    },
    actions: {
        LOGOUT: function ({commit}) {
            commit('setIsLogin', false);
            commit('setUserData', []);
            commit('setAllowSection', []);
            commit('setAuthToken', '');
            commit('setName', '');
            commit('setSecondName', '');
            localStorage.authToken = '';
        },
        //{url, parameter, th, config = {}, getResponse, getSuccessResponse, getHandleError(errorInfo), getError, showSuccessMessage}
        SEND_POST: function ({commit, getters, dispatch}, payload) {
            let config = payload.config !== undefined ? payload.config : {};
            getters.getHttpClient.post(payload.url, payload.parameter, config).then(function (response) {
                let responseData = response.data;
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
                if (responseData.status == 'success') {
                    if (payload.showSuccessMessage === undefined || payload.showSuccessMessage) {
                        commit('setInfoText', 'Операция выполнена успешно');
                        payload.th.$bvModal.show('infoMessage');
                        setTimeout(() => {
                            payload.th.$bvModal.hide('infoMessage');
                        }, 1000);
                    }
                    if (payload.getSuccessResponse != undefined) {
                        payload.getSuccessResponse(responseData);
                    }
                } else {
                    if (payload.getHandleError != undefined) {
                        payload.getHandleError(responseData.errorInfo);
                    } else {
                        dispatch('errorPrepareAndSave', {error: responseData.errorInfo});
                        payload.th.$bvModal.show('errorResponse');
                    }
                }
            }).catch(function (error) {
                console.log('FAILURE!!!');
                console.log(error);
                let errorStr = error.toString();
                if (errorStr.indexOf('status code 401') !== -1) {
                    dispatch('LOGOUT');
                }
                dispatch('errorPrepareAndSave', {error: errorStr});
                payload.th.$bvModal.show('errorResponse');
                if (payload.getError != undefined) {
                    payload.getError();
                }
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
            })
        },
        //{url, th, getResponse, getSuccessResponse(responseData), getHandleError, getError, showSuccessMessage}
        SEND_GET: async function ({commit, getters, dispatch}, payload) {
            await getters.getHttpClient.get(payload.url).then(function (response) {
                let responseData = response.data;
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
                if (responseData.status == 'success') {
                    if (payload.showSuccessMessage === undefined || payload.showSuccessMessage) {
                        commit('setInfoText', 'Операция выполнена успешно');
                        payload.th.$bvModal.show('infoMessage');
                        setTimeout(() => {
                            payload.th.$bvModal.hide('infoMessage');
                        }, 1000);
                    }
                    if (payload.getSuccessResponse != undefined) {
                        payload.getSuccessResponse(responseData);
                    }
                } else {
                    dispatch('errorPrepareAndSave', {error: responseData.errorInfo});
                    payload.th.$bvModal.show('errorResponse');
                    if (payload.getHandleError != undefined) {
                        payload.getHandleError();
                    }
                }
            }).catch(function (error) {
                console.log('FAILURE!!!');
                console.log(error);
                let errorStr = error.toString();
                if (errorStr.indexOf('status code 401') !== -1) {
                    dispatch('LOGOUT');
                }

                dispatch('errorPrepareAndSave', {error: errorStr});
                payload.th.$bvModal.show('errorResponse');
                if (payload.getError != undefined) {
                    payload.getError();
                }
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
            })
        },
        SEND_DELETE: function ({commit, getters, dispatch}, payload) {
            getters.getHttpClient.delete(payload.url).then(function (response) {
                let responseData = response.data;
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
                if (responseData.status == 'success') {
                    if (payload.showSuccessMessage === undefined || payload.showSuccessMessage) {
                        commit('setInfoText', 'Операция выполнена успешно');
                        payload.th.$bvModal.show('infoMessage');
                        setTimeout(() => {
                            payload.th.$bvModal.hide('infoMessage');
                        }, 1000);
                    }
                    if (payload.getSuccessResponse != undefined) {
                        payload.getSuccessResponse(responseData);
                    }
                } else {
                    if (payload.getHandleError != undefined) {
                        payload.getHandleError(responseData.errorInfo);
                    } else {
                        dispatch('errorPrepareAndSave', {error: responseData.errorInfo});
                        payload.th.$bvModal.show('errorResponse');
                    }
                }
            }).catch(function (error) {
                console.log('FAILURE!!!');
                console.log(error);
                let errorStr = error.toString();
                if (errorStr.indexOf('status code 401') !== -1) {
                    dispatch('LOGOUT');
                }
                dispatch('errorPrepareAndSave', {error: errorStr});
                payload.th.$bvModal.show('errorResponse');
                if (payload.getError != undefined) {
                    payload.getError();
                }
                if (payload.getResponse != undefined) {
                    payload.getResponse();
                }
            })
        },
        errorPrepareAndSave: function ({commit}, payload) {
            let text = payload.error;
            if (text.indexOf('|') !== -1) {
                let splitText = text.split('|');
                let end = splitText[splitText.length - 1];
                if (end.indexOf('.php') !== -1) {
                    end = end.split('/');
                    let fileName = end[end.length - 1];
                    splitText.splice((splitText.length - 1), 1);
                    splitText.splice((splitText.length), 0, fileName);
                    commit('setErrorText', splitText.join(' | '));
                    return ;
                }
            }

            commit('setErrorText', text);
        },
        CREATE_PARAMS_URL: function ({getters}, payload) {
            console.log(getters.getName);
            let params = payload.params;
            let urlParams = [];
            for (let prop in params) {
                if (params[prop] !== false && params[prop] !== '') {
                    urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                }
            }
            payload.url.string = '?'+ urlParams.join('&');
        },
        sendAlertCheck: async ({dispatch}, payload) => {
            await dispatch('SEND_GET', {
                url: '/alert/status',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    payload.th.isNewAlert = response.data;
                },
                getResponse: () => {
                    setTimeout(() => {
                        payload.th.alertChecker()
                    }, payload.frequency)
                },
            })
        },
        getSectionList: async ({dispatch, state}, payload) => {
            await dispatch('SEND_GET', {
                url: '/sections',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    state.sections = response.sections;
                },
                getResponse: () => {
                },
            })
        },
    }
});